import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import { portalApi } from '@/api/portal';

const FALLBACK_PLATFORM_NAME = '支付平台';

interface PlatformBrandContextValue {
  platformName: string;
}

const PlatformBrandContext = createContext<PlatformBrandContextValue>({
  platformName: FALLBACK_PLATFORM_NAME,
});

export function PlatformBrandProvider({ children }: { children: ReactNode }) {
  const [platformName, setPlatformName] = useState(FALLBACK_PLATFORM_NAME);

  useEffect(() => {
    let active = true;
    portalApi.siteConfig()
      .then((config) => {
        const name = config.platformName?.trim();
        if (active && name) setPlatformName(name);
      })
      .catch(() => undefined);

    return () => {
      active = false;
    };
  }, []);

  useEffect(() => {
    document.title = `${platformName}支付商户端`;
  }, [platformName]);

  return (
    <PlatformBrandContext.Provider value={{ platformName }}>
      {children}
    </PlatformBrandContext.Provider>
  );
}

export function usePlatformBrand() {
  return useContext(PlatformBrandContext);
}
